import { z } from '@sparelabs/zod'

export enum OrderDirection {
  Ascending = 'ASC',
  Descending = 'DESC',
}

export const OrderDirectionSchema = z.nativeEnum(OrderDirection)
